<template>
	<div class="addPicture">

		<el-upload class="upload" :action="actionUrl" :with-credentials="true" name="uploadFile" :mutiple="false"
			:on-success="handleSuccess" :on-error="handleError">
			<el-button size="small" type="primary">点击上传</el-button>
		</el-upload>

		<div class="com-list">
			<el-table :data="imgs">
				<el-table-column prop="name" label="名称" width="200">
				</el-table-column>
				<el-table-column prop="url" label="地址">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	import { mapActions } from 'vuex'

	export default {
		data() {
			return {
				actionUrl: this.$util.domain + '/adminapi/v1/basicTools/upload/one?uploadImageType=4',
				imgs: []
			}
		},
		methods: {
			...mapActions(['SIGNOUT']),
			beforeAvatarUpload(file) {
				var reader = new FileReader();
				reader.onload = function (e) {
					var data = e.target.result;
					//加载图片获取图片真实宽度和高度
					var image = new Image();
					image.onload = function () {
						var width = image.width;
						var height = image.height;
						// console.log(width + '======' + height + "=====" + file.size);
					};
					image.src = data;
				};
				reader.readAsDataURL(file);
			},
			handleSuccess(response, file) {

				if (response.error === 10000) {
					let name = file.name;
					let url = response.data;

					this.imgs.push({
						name: name,
						url: url
					})
				} else {
					this.$util.errorMsg('上传失败');
				}

			},
			handleError(response) {

				if (response.status === 403) {
					this.SIGNOUT();
					location.href = '/#';
				}

				this.$util.errorMsg('上传失败');
			}
		}
	}
</script>
<style>
	.upload {
		margin-left: 30px;
		margin-top: 30px;
		margin-bottom: 30px;
	}
</style>


// WEBPACK FOOTER //
// addPicture.vue?7dceaeb0